import { CardHeadingGroup, CardNav } from '@storeblocks/card';
import { type FC } from 'react';
import { Link } from 'react-router';

import { CardColumn, Row } from '@/components/Grid';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const NewsLinks: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <Row>
      <CardColumn $span={6} key={texts.news.links.marketReport.title}>
        <CardNav
          icon="search"
          id={texts.news.links.marketReport.link}
          orientation="horizontal"
        >
          {(ref: React.Ref<HTMLAnchorElement>) => (
            <CardHeadingGroup
              ref={ref}
              heading={texts.news.links.marketReport.title}
              as={Link}
              to={texts.news.links.marketReport.link}
              target="_blank"
              data-trackid={getTrackId(
                `go-to-${texts.news.links.marketReport.title
                  .trim()
                  .toLowerCase()
                  .replace(/\s/g, '-')}`,
                TrackingElement.Link,
              )}
            />
          )}
        </CardNav>
      </CardColumn>
      <CardColumn $span={6} key={texts.news.links.publications.title}>
        <CardNav
          icon="files"
          id={texts.news.links.publications.link}
          orientation="horizontal"
        >
          {(ref: React.Ref<HTMLAnchorElement>) => (
            <CardHeadingGroup
              ref={ref}
              heading={texts.news.links.publications.title}
              as={Link}
              to={texts.news.links.publications.link}
              target="_blank"
              data-trackid={getTrackId(
                `go-to-${texts.news.links.publications.title
                  .trim()
                  .toLowerCase()
                  .replace(/\s/g, '-')}`,
                TrackingElement.Link,
              )}
            />
          )}
        </CardNav>
      </CardColumn>
    </Row>
  );
};
